import { Collapse as AntdCollapse, CollapseProps as AntdCollapseProps } from 'antd';

type CollapseProps = AntdCollapseProps;

const Collapse = (props: CollapseProps) => <AntdCollapse {...props} />;

export default Collapse;
